import { IsArray, IsObject } from './typeof.types'

export const isObject: IsObject = obj => (
  !Array.isArray(obj) &&
  typeof obj === 'object'
)

export const isArray: IsArray = array => (
  Array.isArray(array)
)
